import { Client, NoticeEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import MessageHandler from '#/messageHandler';
import TabManager from '#/ui/tabManager';

export class NoticeEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.NOTICE, (event: NoticeEvent) => {
            const { from_server, nick, ident, hostname, target, group, message, tags, time, account, batch } = event;
            if (target && target.startsWith('#')) {
                const channelTab = this.tM.getTab(tabType.CHANNEL, target) ?? this.tM.getStatusTab();
                this.mH.addMessage(channelTab, message, IRCMessageType.NOTICE, nick ? nick : hostname);
                this.mH.addMessage(this.tM.getStatusTab(), `[${target}] ${message}`, IRCMessageType.NOTICE, nick ? nick : hostname);
            } else {
                const activeTab = this.tM.getActiveTab() ?? this.tM.getStatusTab();
                if (activeTab !== this.tM.getStatusTab()) {
                    this.mH.addMessage(this.tM.getStatusTab(), message, IRCMessageType.NOTICE, nick ? nick : hostname);
                }
                this.mH.addMessage(activeTab, message, IRCMessageType.NOTICE, nick ? nick : hostname);
            }
        });
    }
}